export const initialValues = {
  param: '',
  bookType: [],
  category: [],
  penName: [],
}
